$( document ).ready(function() {
    
	if ($('body').attr('id') == 'templates-2016') {
        
        $("a.template-link").click(function () {
            dataLayer.push({
                'event' : 'mjml',
                'eventValue' : 'mjmlTpl-CtaClicked',
                'template-name' : $(this).closest(".template").data("template")
            });
        });
        
        $("input[name=search-input]").keyup(function() {
            $(".template").removeClass("hide");
            $(".empty-result").addClass("hide");
            var search = $(this).val();
            removeMissingTemplate();
            if (search != "") {
                var regex = new RegExp(search, "i");
                $(".template").each(function() {
                    if(!regex.test($(this).data("tags")) && !regex.test($(this).data("author")) && !regex.test($(this).data("template")) && !regex.test($(this).data("desc"))) {
                        $(this).addClass("hide");
                    }
                });
                if ($(".template:not(.hide)").length == 0) {
                    $(".empty-result").removeClass("hide");
                }
            }
            addMissingTemplate();
        });
        
        $("select[name=filter-select]").change(function() {
            var filter = $(this).val();
            handleTagChange(filter);
            changeTitleAndHistory(filter);
        });
        
        $(".filter-container, .search-container").submit(function(e) {
            e.preventDefault();
            return false;
        });
        
        $(window).resize(function() {
            removeMissingTemplate();
            addMissingTemplate();
        });
        
        function addMissingTemplate() {
            if ($(window).width() >= 1024 && $(".template:not(.hide)").length % 3 == 2) {
                $(".gallery").append("<div class='fake-template'></div>");
            }
        }
        
        function removeMissingTemplate() {
            if ($(window).width() < 1024 || $(".fake-template").length > 0) {
                $(".fake-template").remove();
            }
        }
        
        window.addEventListener('popstate', function(e) {
            if (e.state.tag != "all") {
                $("select[name=filter-select]").val(e.state.tag);
            } else {
                $("select[name=filter-select]").val("all");
            }
            handleTagChange(e.state.tag);
            changeTitle();
        });
        
        function changeTitleAndHistory(tag) {
            var newURL = "";
            if (tag != "all") {
                newURL = "/templates/" + tag + "-email";
            } else {
                newURL = "/templates";
            }
            changeTitle();
            history.pushState({tag: tag}, document.title, newURL);
        }
        
        function handleTagChange(tag) {
            $(".template").removeClass("hide");
            $(".empty-result").addClass("hide");
            removeMissingTemplate();
            if (tag != "all") {
                var regex = new RegExp(tag, "i");
                $(".template").each(function() {
                    if(!regex.test($(this).data("tags"))) {
                        $(this).addClass("hide");
                    }
                });
                if ($(".template:not(.hide)").length == 0) {
                    $(".empty-result").removeClass("hide");
                }
            }
            addMissingTemplate();
        }
        
        function changeTitle() {
            var tag = $("select[name=filter-select]").val();
            var newTitle = "";
            if (tag != "all") {
                newTitle = tag.charAt(0).toUpperCase() + tag.slice(1) + " email templates";
            } else {
                newTitle = "Responsive Email Templates";
            }
            document.title = newTitle;
            $(".title").html(newTitle);
        }
        
        var defaultTag = $(".gallery").data("tag");
        if (defaultTag != "" && defaultTag != null) {
            defaultTag = defaultTag.split("-email")[0];
            $("select[name=filter-select]").val(defaultTag);
            // Check if the tag is a real one.
            if ($("select[name=filter-select]").val() != null) {
                handleTagChange(defaultTag);
                changeTitleAndHistory(defaultTag);
            }
        }
        
    }
});